import List from "@elements/List/List";
import { ListItem } from "@elements/List/ListItem/ListItem";
import { HeaderMenuType } from "@header/HeaderMenuTypes";
import { HeaderMenuDetails } from "@typings/constants";
import { Link, useLocation } from "react-router";
import { twMerge } from "tailwind-merge";

type HeaderMenuListProps = {
  testId: string;
  items: HeaderMenuDetails[];
  type: HeaderMenuType;
  scrolled?: boolean;
  bigHeader?: boolean;
};

export function HeaderMenuList({
  testId,
  items,
  type,
  scrolled = false,
  bigHeader = false,
}: HeaderMenuListProps) {
  const currentUrl = useLocation().pathname;
  const sectionName = currentUrl.split("/").filter(Boolean)[0];

  return (
    <List
      testId={`${testId}-${type}-list`}
      className={twMerge(
        "block",
        type === "social" && "inline-flex xmd:pt-0 my-xxsm items-center",
        type === "main" &&
          "flex lg:w-full lg:relative gap-7 md:gap-6 lg:gap-7 overflow-scroll xmd:overflow-auto xmd:justify-end md:pt-2 md:pb-0.5 lg:pb-0 lg:pt-xs pb-2",
        type === "main" &&
          (scrolled || !bigHeader) &&
          "items-end !pt-0 lg:justify-center !gap-1 ml-4",
        type === "hamburger" && "block md:px-5",
      )}
    >
      {items.map((item: HeaderMenuDetails, index: number) => (
        <ListItem
          key={`${testId}-item-${index}`}
          testId={`${testId}-item-${index}`}
          className={twMerge(
            "font-opensans text-grey-300",
            type === "social" && "pr-3",
            type === "main" && item.url && "md:px-3 lg:px-0 lg:flex",
            type === "main" && (scrolled || !bigHeader) && "xmd:pb-0 lg:px-sm",
            type === "main" && index === items.length - 1 && "lg:pr-0",
            type === "hamburger" && "text-black px-4 py-2 mb-2",
            type === "hamburger" &&
              index === items.length - 1 &&
              "border-t border-black pt-6 mx-4 px-0 border-opacity-[0.3]",
            type === "hamburger" && index === items.length - 2 && "mb-4",
          )}
        >
          <Link
            reloadDocument
            key={index}
            to={item.url}
            target={item.newTab ? "_blank" : "_self"}
            rel="noreferrer"
            className={twMerge(
              "font-semibold text-sm leading-5",
              item.images && item.title && "inline-flex",
              type === "main" &&
                "hover:text-grey-400 font-semibold xmd:font-bold font-opensans text-sm lg:text-base leading-6 w-max block lg:px-5 lg:py-2.5",
              type === "main" && (scrolled || !bigHeader) && "lg:py-1",
              type === "main" && currentUrl === item.url && "text-grey-400",
              type === "main" &&
                `/${sectionName}` === item.url &&
                "text-grey-400",
              type === "main" && index === items.length - 1 && "lg:pr-0",
              type === "hamburger" &&
                "text-black text-xxl font-bold font-primary leading-8",
            )}
          >
            {item.images ? (
              <img
                height={item.height}
                width={item.width}
                src={item.images}
                alt={`${item.alt}-icon`}
                loading="lazy"
                className={twMerge(
                  "h-5",
                  type === "social" && "lg:h-auto",
                  type === "main" && "xmd:h-auto xmd:w-xl xmd:mt-1",
                )}
              />
            ) : null}
            {item.title}
          </Link>
        </ListItem>
      ))}
    </List>
  );
}
